/*global fbq, */
/*global gtag, */
/*eslint no-undef: "error"*/

const MIN_ADS_SHOW_COUNT = 3;

class AnalyticsService {
    constructor() {
        if (!AnalyticsService.instance) {
            this.consts = {
                MIN_ADS_SHOW_COUNT
            }
            
            this.events = {
                PARTICIPATE_MAIN: 'click_participate_main',
                PARTICIPATE_MOBILE_LIVE_MUSIC: 'click_participate_mobile_livemusic',
                PARTICIPATE_MOBILE_SERVICE: 'click_participate_mobile_service',
                PARTICIPATE_MOBILE_BAND: 'click_participate_mobile_band',
                PARTICIPATE_MOBILE_MUSICIAN: 'click_participate_mobile_musician',
                LOG_IN: 'login',
                SIGN_UP: 'sign_up',
                TOP_FILTER: 'filter_selected_nav', // select mugics type
                WATCH_VIDEO: 'click_video_btn_main',
                WATCH_VIDEO_NAV: 'click_video_nav',
                SEARCH_CAT_CHANGE: 'click_search_category',
                OPEN_PIN: 'open_mosaic_ad',
                SHARE: 'share',
                SELECT_FILTER_CAT: 'select_category_filter',
                OPEN_SUBMIT_MODAL: 'open_submit_ad',
                SUBMIT_AD: 'submit_new_ad',
                SELECT_PAID_PLAN: 'clicked_paid_plan',
                PURCHASE: 'Purchase',
                CLICK_CAT_OPEN_STAGE: 'search_open_stage',
                CLICK_CAT_PLACES_PERFORM: 'search_places_perform',
                OPEN_PIN_OPENMIC_ABOVE: `open_ad_openmic_above_${MIN_ADS_SHOW_COUNT}`,
                OPEN_PIN_PLACES_TO_SHOW_ABOVE: `open_ad_places_to_show_above_${MIN_ADS_SHOW_COUNT}`,
                OPEN_PIN_LIVE_MUSIC_ABOVE: `open_ad_live_music_above_${MIN_ADS_SHOW_COUNT}`,
            };

            this.fbEvents = {

            }

            this.gaDefualtEvents = {
                login: method => ({ method }),
                sign_up: method => ({ method }),
                share: ([item_id, content_type]) => ({ item_id, content_type }),
                search: search_term => ({ search_term })
            };

            this.settings = {
                isDisabled: false
            }

            AnalyticsService.instance = this;
        }

        return AnalyticsService.instance;
    }

    init(user) {
        this.settings.isDisabled = user.isAnalyticsDisabled
    }

    sendEvent(eventStr, eventPayload, eventValue, fbPayload) {
        if (process.env.REACT_APP_ENV !== 'production' || this.settings.isDisabled) return;

        // check if user analytics is disabled

        // trigger FB event
        this.sendEventFB(eventStr, eventPayload, fbPayload);

        // trigger Google Analytics event
        this.sendEventGA(eventStr, eventPayload, eventValue);
    }

    sendEventFB(eventStr, payload) {
        if (typeof fbq === 'undefined') return;

        const trackStr = eventStr === this.events.PURCHASE ? 'track' : 'trackCustom';

        fbq(trackStr, eventStr, payload ? payload : null);
    }

    // TODO: handle purchase event here too
   sendEventGA(eventStr, eventPayload, eventValue) {
       if (typeof gtag === 'undefined') return;

       let gaPayload = {};

       if (this.gaDefualtEvents[eventStr]) {
           gaPayload = this.gaDefualtEvents[eventStr](eventPayload)
       } else {
           gaPayload = {
               event_category : 'user_interaction',
               event_label : typeof eventPayload === 'string' ? eventPayload : 'click',
           };

           if (eventValue) gaPayload.value = eventValue;
       }

       gtag('event', eventStr, gaPayload);
    }
}

const instance = new AnalyticsService();
Object.freeze(instance);

export default instance;



// WEBPACK FOOTER //
// ./src/Services/AnalyticsService.js